import React, { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import NwSegmented from '@components/Gui/NwForm/NwSegmented';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledSegmented = styled(NwSegmented)`
    .label {
        padding: 0.5rem;

        .label-icon {
            font-size: 1.2rem;
            min-height: 1.9rem;
        }
        .label-text {
            font-size: 1rem;
            text-transform: uppercase;
        }

        /* con 4 voci le etichette non ci stanno su schermi stretti:
           via le icone e testo più piccolo */
        @media (max-width: ${(props) => props.theme.NarrowScreenMaxWidth}) {
            padding: 0.25rem;

            .label-icon {
                display: none;
            }
            .label-text {
                font-size: 0.7rem;
            }
        }
    }
    .ant-segmented-item-selected {
        .label {
            .label-icon {
                color: ${(props) => props.theme.PrimaryColor};
            }
            &.empty {
                .label-icon {
                    color: ${(props) => props.theme.TextColorMuted};
                }
                .label-text {
                    font-weight: normal;
                    color: ${(props) => props.theme.TextColorMuted};
                }
            }
        }
    }
`;

const SegmentedOptionContent = ({ text, icon, empty }) => (
    <div className={`label ${empty ? 'empty' : ''}`}>
        <div className="label-icon">{icon && <NwIcon icon={icon} />}</div>
        <div className="label-text">{text}</div>
    </div>
);

const AgencyTypeSelector = ({ asSegmented, emptyValue, hideMother, onChange, value }) => {
    const { cachedList } = useContext(ListContext);

    const modelAgenciesTypesOptions = [];
    if (cachedList && cachedList.enumerators && cachedList.enumerators.items) {
        const modelAgenciesTypesEnum = cachedList.enumerators.items.find((el) => {
            return el.Name === 'ModelAgencyTypeEnum';
        }).Values;
        const modelAgenciesTypesEnumToOptions = modelAgenciesTypesEnum.map((el) => {
            const disabled = el.Name === 'Mother' && hideMother;
            return { disabled: disabled, value: el.Name, label: el.Name };
        });
        modelAgenciesTypesOptions.push(...modelAgenciesTypesEnumToOptions);
        if (emptyValue) {
            modelAgenciesTypesOptions.unshift({ value: null, label: 'Any Type' });
        }
    }

    const optionsAsSegmented = modelAgenciesTypesOptions.map((el) => {
        switch (el.value) {
            case null:
                return {
                    label: <SegmentedOptionContent text="Any" icon={byPrefixAndName.fasl['asterisk']} empty />,
                    value: null,
                };
            case 'Mother':
                return {
                    label: <SegmentedOptionContent text="Mother" icon={byPrefixAndName.fasl['medal']} />,
                    value: 'Mother',
                };
            case 'Placement':
                return {
                    label: <SegmentedOptionContent text="Placement" icon={byPrefixAndName.fasl['handshake']} />,
                    value: 'Placement',
                };
            default:
                return {
                    label: <SegmentedOptionContent text={el.label} icon={byPrefixAndName.fasl['globe']} />,
                    value: el.value,
                };
        }
    });

    if (asSegmented || emptyValue) {
        return (
            <StyledSegmented
                value={value}
                onChange={onChange}
                options={optionsAsSegmented}
                defaultValue={emptyValue ? null : false}
            />
        );
    }
    return <RadioButtonGroup value={value} onChange={onChange} options={modelAgenciesTypesOptions} />;
};

export { AgencyTypeSelector };
